import { render } from "./news-and-community.vue?vue&type=template&id=aa2ef726&scoped=true"
import script from "./news-and-community.vue?vue&type=script&lang=js"
export * from "./news-and-community.vue?vue&type=script&lang=js"

import "./news-and-community.vue?vue&type=style&index=0&id=aa2ef726&scoped=true&lang=css"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2ef726"]])

export default __exports__